export const tabStyles = {
  styleOverrides: {
    root: {
      '&.Mui-selected': {
        color: 'inherit',
      },
    }
  }
}
